"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@21st-night/core");
var AchievementSnackbar_1 = __importDefault(require("./AchievementSnackbar"));
var achievements_1 = __importDefault(require("./achievements"));
var GoldCounterPopoverContainer = function () {
    var user = core_1.useUser();
    var _a = __read(react_1.useState(false), 2), open = _a[0], setOpen = _a[1];
    var _b = __read(react_1.useState(user.latestAchievement), 2), previousAchievement = _b[0], setPreviousAchievement = _b[1];
    var achievement = user.latestAchievement || {
        type: 'cards-created',
        count: 10,
    };
    react_1.useEffect(function () {
        if (user.latestAchievement &&
            (!previousAchievement ||
                core_1.toDate(user.latestAchievement.earnedAt).getTime() !==
                    core_1.toDate(previousAchievement.earnedAt).getTime())) {
            setPreviousAchievement(user.latestAchievement);
            setOpen(true);
        }
    }, [previousAchievement, user.latestAchievement]);
    return (react_1.default.createElement(AchievementSnackbar_1.default, { message: achievements_1.default[achievement.type]
            ? achievements_1.default[achievement.type].title(achievement.count)
            : '', open: open, onClose: function () { return setOpen(false); } }));
};
exports.default = GoldCounterPopoverContainer;
//# sourceMappingURL=AchievementSnackbarContainer.js.map